module.exports = __webpack_public_path__ + "static/media/foto1.1b515cd4.png";